import { CopyIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Select,
  Stack,
} from '@chakra-ui/react'
import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore'
import { useState } from 'react'
import { Lab } from '../../../types/bloodWork'

export default ({
  labs,
  copyButtonFunc,
}: {
  labs: QueryDocumentSnapshot<Lab, DocumentData>[] | undefined
  copyButtonFunc: (
    copyLabId: string,
    labs: QueryDocumentSnapshot<Lab, DocumentData>[]
  ) => boolean
}) => {
  //   const [saving, setSaving] = useState(false);
  const [copyLabId, setCopyLabId] = useState('')

  return (
    <>
      <Stack spacing={2}>
        <FormControl maxW='md'>
          <FormLabel>Copy Existing Lab</FormLabel>
          <Select
            maxW='md'
            placeholder='Choose Lab to Copy'
            value={copyLabId}
            onChange={(e) => {
              setCopyLabId(e.target.value)
            }}
          >
            {labs &&
              labs.map((doc) => {
                return (
                  <option value={doc.id} key={doc.id}>
                    {doc.data().title}
                  </option>
                )
              })}
          </Select>
        </FormControl>
        {labs && (
          <Box>
            <Button
              colorScheme='gray'
              leftIcon={<CopyIcon />}
              isDisabled={!copyLabId}
              onClick={() => {
                if (copyButtonFunc(copyLabId, labs)) {
                  setCopyLabId('')
                }
              }}
            >
              Copy
            </Button>
          </Box>
        )}
      </Stack>
    </>
  )
}
